import OrganizationRepository from '../../domain/repository/OrganizationRepository';
import OrganizationStore from '../../domain/store/OrganizationStore';
import UiState from '../../domain/store/UiState';
import config from '../../config';

export class OrganizationUsecase {
  private organizationRepository: OrganizationRepository;
  private organizationStore: OrganizationStore;
  private uiState: UiState;

  constructor({
    organizationRepository,
    organizationStore,
    uiState,
  }: {
    organizationRepository: OrganizationRepository;
    organizationStore: OrganizationStore;
    uiState: UiState;
  }) {
    this.organizationRepository = organizationRepository;
    this.organizationStore = organizationStore;
    this.uiState = uiState;
  }

  public async getOrganizations() {
    const { organizationRepository, organizationStore, uiState } = this;
    await uiState.clearError();
    await organizationStore.setLoading(true);

    const organizations = await organizationRepository.getOrganizationsOfCurrentUser();
    const organizationIdFromUrl = organizationRepository.getSelectedOrganizationIdFromUrl();
    if (organizationIdFromUrl) {
      organizationStore.setSelectedOrganizationId(organizationIdFromUrl);
    }
    if (organizations.length === 0) {
      uiState.setError({
        title: 'Round Monitor を利用できる組織が存在しません。',
        message: `詳しくは<a href="${config.help_page_url}" target="_blank" rel="noreferrer noopener">ヘルプページ</a>をご確認の上、お問い合わせください。`,
      });
      throw new Error('No available organizations');
    }

    if (organizationIdFromUrl) {
      if (!organizations.find(org => org.id === organizationIdFromUrl)) {
        uiState.setError({
          title: '指定された組織は存在しないか、Round Monitor を利用できる組織ではありません。',
          message: `詳しくは<a href="${config.help_page_url}" target="_blank" rel="noreferrer noopener">ヘルプページ</a>をご確認の上、お問い合わせください。`,
        });
        throw new Error(`Organization is not found: ${organizationIdFromUrl}`);
      }
    } else {
      organizationStore.setSelectedOrganizationId(organizations[0].id);
    }
    organizationStore.addOrganizationList(organizations);
    organizationStore.setLoading(false);
  }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/application/usecase/OrganizationUsecase.ts